
const communityLinks = [
    {
        name: 'BILIBILI 哔哩哔哩',
        link: 'https://space.bilibili.com/312350412?spm_id_from=333.337.search-card.all.click'
    },
    {
        name: 'DOUYIN 抖音',
        link: 'https://www.douyin.com/user/MS4wLjABAAAAEJSnltZ_FoCWF4ZTUAFOoRtij2-JfV-Gwoa_2yQpkVQ?from_tab_name=main'
    },
    {
        name: 'RED 小红书',
        link: 'https://www.xiaohongshu.com/user/profile/63f5bc6e000000001001ebdd?xsec_token=AB5uRBhGSfI55nzZ6LDVEqQXoFeWuD8zUtxrsDYI0AfEE%3D&xsec_source=pc_search'
    },
    {
        name: 'X (TWITTER)',
        link: 'https://x.com/IceSoulKB'
    }
]

const filingInfo = {
    name: '辽ICP备2023005102号-2',
    link: 'https://beian.miit.gov.cn/'
}

const performanceMatrix = [
    {
        label: 'Temperature Control',
        value: 1,
        des: '温度控制：发热元件分区布局，采用DCDC+LDO组合供电，并精选低PCB热阻元件。'
    },
    {
        label: 'Signal Performance',
        value: 2,
        des: '信号性能：采样时序与USB噪声同步，有效避开USB通信噪声，实现无额外延迟的信号传输。'
    },
    {
        label: 'Response Delay',
        value: 3,
        des: '响应延迟：全线产品追求 0.1ms 级响应时延，消除人类意图与数字反馈间的壁垒。'
    },
    {
        label: 'Lighting System',
        value: 4,
        des: '灯光系统：以独立RGB灯控电路取代传统串灯方案，高效可靠，光影从容。'
    },
    {
        label: 'Adjustable Precision',
        value: 5,
        des: '可调精度：响应参数（RT）可低至 0.005mm，可实现 0.001mm 级别精度控制。'
    },

]

const productSelection = [
    // {
    //     productName: 'IceSoul 64LiM',
    //     productId: 1,
    //     des: '全新自研LiM方案，以电路革新，重塑输入基准。',
    //     imgSrc: ''
    // },
    {
        productName: 'IceSoul 60LiM',
        productId: 1,
        des: '极致性能，多种配列，全能与百变，不必妥协。',
        imgSrc: require('../assets/img/product4.jpg')
    }
]

const productList = [
    // {
    //     productName: 'IceSoul 64LiM',
    //     isOpen: true,
    //     productId: 1,
    //     productType: 'KEYBOARDS',
    //     productDes: '为极致电竞而生。搭载IceSoul全新自研LiM磁轴方案，最低可调RT 0.005mm。超低延迟，瞬时触发。',
    //     parameter: [
    //         {
    //             parameterName: 'Polling Rate',
    //             parameterValue: '8K Hz'
    //         },
    //         {
    //             parameterName: 'Switch Type',
    //             parameterValue: '磁轴'
    //         },
    //         {
    //             parameterName: 'Profile',
    //             parameterValue: '有线'
    //         },
    //         {
    //             parameterName: 'Latency',
    //             parameterValue: '0.132 ms'
    //         }
    //     ],
    //     imgSrc: ''
    // },
    {
        productName: 'IceSoul 60LiM',
        isOpen: true,
        productId: 1,
        productType: 'KEYBOARDS',
        productDes: '搭载IceSoul全新自研LiM磁轴方案的同时，还兼容多种配列。性能无妥协，配列随心换。让你的键盘不再无趣！',
        parameter: [
            {
                parameterName: 'Polling Rate',
                parameterValue: '8K Hz'
            },
            {
                parameterName: 'Switch Type',
                parameterValue: '磁轴'
            },
            {
                parameterName: 'Profile',
                parameterValue: '有线'
            },
            {
                parameterName: 'Latency',
                parameterValue: '0.132 ms'
            }
        ],
        imgSrc: require('../assets/img/product2.jpg')
    },
    // {
    //     productName: 'IceSoul 60WL',
    //     isOpen: false,
    //     productId: 3,
    //     productType: 'KEYBOARDS',
    //     productDes: 'IceSoul工作室首款双模磁轴方案，低延迟，低功耗。磁力感应，无线自由。',
    //     parameter: [
    //         {
    //             parameterName: 'Polling Rate',
    //             parameterValue: '8K Hz(有线) / 4K Hz(2.4G)'
    //         },
    //         {
    //             parameterName: 'Switch Type',
    //             parameterValue: '磁轴'
    //         },
    //         {
    //             parameterName: 'Profile',
    //             parameterValue: '有线 / 2.4G'
    //         },
    //         {
    //             parameterName: 'Latency',
    //             parameterValue: '0.2 ms(有线) / 0.4 ms(2.4G)'
    //         }
    //     ],
    //     imgSrc: ''
    // }
]

const faultDoc = [
    {
        docName: '磁轴键盘按键常见问题排除',
        docId: 1,
        docCreationTime: '2025.11.11'
    }
]

export {
    communityLinks,
    filingInfo,
    performanceMatrix,
    productSelection,
    productList,
    faultDoc
}
